import moment from "moment";

const kuaaFormatter = {
  /**
   * 교우 성별 리턴
   * @param type
   * @returns {string}
   */
  getSexLetter(type){
    let str = "";
    switch (type){
      case "F":
        str = "여";
        break;
      case "M":
        str = "남";
        break;
      default:
        str = "-";
    }
    return str;
  },

  /**
   * 교우 상태 (정상/작고) 리턴
   * @param status
   * @returns {string}
   */
  getStatusLetter(status){
    let str = "";
    switch (status){
      case "1":
        str = "정상";
        break;
      case "2":
        str = "작고";
        break;
      default:
        str = "-";
    }
    return str;
  },

  /**
   * 날짜 포맷 설정
   * @param date
   * @returns {string|*}
   */
  getDateFormat(date){
    // TODO: 날짜 포맷이 정해지면 그에 맞춰 문자열 조정

    if (date && date.length){
      let yyyy = date.substr(0, 4);
      let mm = "-" + date.substr(4, 2);
      let dd = (date.length > 6) ? "-" + date.substr( 6, 2) : "";
      return yyyy + mm + dd;
    } else {
      return date;
    }
  },

  /**
   * 주민등록번호 (마스킹 포함)
   * @param registerNumber
   * @param sex
   * @returns {string}
   */
  getRegisterNumberFormat(registerNumber, sex){
    if (!registerNumber)
      return "-";

    let suffix = "******";
    let sexType;
    switch (sex){
      case "F":
        sexType = "2";
        break;
      case "M":
        sexType = "1";
        break;
      default:
        sexType = "*";
    }
    return registerNumber + "-" + sexType + suffix;
  },

  /**
   * 숫자 세 자리마다 콤마 추가
   * @param num
   * @returns {string}
   */
  getCurrency(num) {
    return num ? num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,') : 0;
  },

  /**
   * 전화번호 포매팅.
   * @param telephoneNumber
   * @returns {{tel1: *, tel2: *, tel3: *}}
   */
  getTelObject(telephoneNumber){
    let dashed = telephoneNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
    let arr = dashed.split('-');
    return {
      tel1: arr[0],
      tel2: arr[1],
      tel3: arr[2]
    };
  },
  
  getPhoneMask(telephoneNumber){
	let dashed = telephoneNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
	return dashed;
  },

  customFormatter(date) {
    let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
    return res;
  },
};
export default kuaaFormatter;
